import { twMerge } from 'tailwind-merge';

import { useTheme } from '@/_shared';

import type { HelperTextProps } from './types';

export const HelperText = (props: HelperTextProps) => {
  const { children, valid, className, ...other } = props;
  const { helperText } = useTheme();

  const validationStyle = (iValid: boolean | undefined): string => {
    switch (iValid) {
      case true:
        return helperText.valid;
      case false:
        return helperText.invalid;
      default:
        return '';
    }
  };

  const cls = twMerge(helperText.base, validationStyle(valid), className);

  return (
    <div className={cls} {...other}>
      {children}
    </div>
  );
};
